// @flow
import { styled } from 'mz-ui-kit'

// Constants
const ARROW_PLACEMENT = {
  top: {
    bottom: '-5px',
    transform: 'rotate(45deg)',
  },
  bottom: {
    top: '-5px',
    transform: 'rotate(-135deg)',
  },
  left: {
    right: '-5px',
    transform: 'rotate(-45deg)',
  },
  right: {
    left: '-5px',
    transform: 'rotate(135deg)',
  },
}
const CONTAINER_PLACEMENT = {
  top: { marginBottom: '8px' },
  bottom: { marginTop: '8px' },
  left: { marginRight: '8px' },
  right: { marginLeft: '8px' },
}

// Utils
export const Container = styled<{
  $color: string,
  $width: string,
  $placement: string,
  $showed: boolean,
}>('div', ({ $color, $width, $placement, $showed, $palette }) => ({
  zIndex: 100000,
  background: `${$palette($color)}`,
  color: $palette($color).darken(20).isLight() ? 'black' : 'white',
  width: $width,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '10px 15px',
  borderRadius: '3px',
  borderStyle: 'solid',
  borderColor: `${$palette('gray')}`,
  borderWidth: '1px',
  transition: 'opacity 650ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  opacity: $showed ? 1 : 0,
  pointerEvents: $showed ? 'inherit' : 'none',
  ...CONTAINER_PLACEMENT[$placement],
}))

export const Arrow = styled<{
  $color: string,
  $placement: string,
}>('div', ({ $color, $placement, $palette }) => ({
  position: 'absolute',
  content: '""',
  height: '10px',
  width: '10px',
  background: `${$palette($color)}`,
  zIndex: -1,
  borderStyle: 'solid',
  borderColor: `${$palette('gray')}`,
  borderWidth: '0 1px 1px 0',
  ...ARROW_PLACEMENT[$placement],
}))
